export { DesktopProposalTable } from './components/DesktopProposalTable' 
export { MobileProposalTable } from './components/MobileProposalTable'
export { ProposalTable } from './components/ProposalTableWithHint'
